// src/modules/app-views/_apps/appmulti/operators/components/OperatorApiTag.jsx
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { Tag, Tooltip } from 'antd';
import { TbPlugConnectedX, TbPlugConnected } from 'react-icons/tb';
import { PiPlugsConnectedBold } from 'react-icons/pi';
import translateX from 'utils/translateX';
import operatorsService from 'modules/app-views/_apps/appmulti/operators/service';

// *******************************************************************************
// MAIN COMPONENT
// *******************************************************************************
const OperatorApiTag = props => {
  // ─────────────────────────────────────────────────────────────────────────────
  // 1. PROPS, CONTEXTS & GLOBAL STATE
  // ─────────────────────────────────────────────────────────────────────────────
  const cnpjValue =
    props?.documents?.find(d => d.documentType === 'cnpj')?.value ||
    props?.cnpj?.value ||
    '';
  const hasApiMatch = !!operatorsService.resolveProviderByCnpj(cnpjValue);
  const apiEnabled = props?._integrations?.apiEnabled;
  const hasCredentials = !!(
    props?._integrations?.apiCredentials?.login && props?._integrations?.apiCredentials?.password
  );

  // ─────────────────────────────────────────────────────────────────────────────
  // 8. UI
  // ─────────────────────────────────────────────────────────────────────────────
  const tag = buildApiTag(hasApiMatch, apiEnabled, hasCredentials);

  return (
    <Tooltip title={tag.tooltip}>
      <Tag
        color={tag.color}
        icon={tag.icon}
        style={{
          margin: 0,
          fontSize: 10,
          lineHeight: '16px',
          padding: '0 4px',
          display: 'inline-flex',
          alignItems: 'center',
          gap: 2,
        }}
      >
        {tag.label}
      </Tag>
    </Tooltip>
  );
};

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default OperatorApiTag;

// *******************************************************************************
// HELPERS
// *******************************************************************************
function buildApiTag(hasApiMatch, apiEnabled, hasCredentials) {
  if (!hasApiMatch) {
    return {
      color: 'red',
      icon: <TbPlugConnectedX style={{ fontSize: 12 }} />,
      label: translateX('no_api'),
      tooltip: translateX('no_api_integration'),
    };
  }

  if (apiEnabled && hasCredentials) {
    return {
      color: 'blue',
      icon: <PiPlugsConnectedBold style={{ fontSize: 12 }} />,
      label: 'API',
      tooltip: translateX('api_connected'),
    };
  }

  return {
    color: 'gold',
    icon: <TbPlugConnected style={{ fontSize: 12 }} />,
    label: 'API',
    tooltip: translateX('api_disconnected'),
  };
}
